import { render, staticRenderFns } from "./SignupWithSmsAuth.vue?vue&type=template&id=cfc9394c&"
import script from "./SignupWithSmsAuth.vue?vue&type=script&lang=ts&"
export * from "./SignupWithSmsAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports